import { gql } from "apollo-boost"

export const getAwsLink = gql`
  mutation getAAwsLink($key:String!){
    getUrl(key:$key){
      url
      existsInBucket
    }
  }
`


export const DeleteAwsFile = gql`
  mutation getSignedUrlForDelete($fileKey:String!){
    getSignedUrlForDelete(fileKey:$fileKey){
      url
      existsInBucket
    }
  }
`

export const setAwsDocument = gql`
  mutation updateFileAws($mimetype:String!, $filename:String!){
    updateFileAws(mimetype:$mimetype, filename:$filename){
      url
      fileKey
    }
  }
`